// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__2xwIR","checkboxCol":"Table_checkboxCol__3yPLh","emailCol":"Table_emailCol__38Bgm","actionCol":"Table_actionCol__2R1TE"};